import React, {useContext, FunctionComponent} from 'react';
import './ModifierGroupEdit.less';
import {Button} from 'elements/button/Button';
import {DrawerPopup} from 'dialog-layout/drawer-popup/DrawerPopup.tsx';
import {TranslationsContext} from 'contexts/translations-context';
import {getSafeTranslation} from 'helpers/localization.helper.ts';
import {ModifierGroup, ModifierGroupSelections, ModifierGroupId} from 'helpers/modifier.helper.types.ts';
import {SelectManyModifierGroupEdit} from '../../compositions/select-many-modifer-group-edit/SelectManyModifierGroupEdit';
import {SelectOneModifierGroupEdit} from '../../compositions/select-one-modifier-group-edit/SelectOneModifierGroupEdit';
import {QuantitiesModifierGroupEdit} from '../../compositions/quantities-modifier-group-edit/QuantitiesModifierGroupEdit';
import {Stepper} from '../../compositions/stepper/Stepper';
import {Card} from '../../elements/card/Card';
import {HeaderCard} from '../../elements/header-card/HeaderCard';

export const MODIFIER_GROUP_EDIT_POPUP = 'MODIFIER_GROUP_EDIT_POPUP';
export const CART_MODIFIER_GROUP_EDIT_POPUP = 'CART_MODIFIER_GROUP_EDIT_POPUP';//

interface ModifierGroupEditProps {
	modifierGroup: ModifierGroup,
	modifierGroupSelections: ModifierGroupSelections,
	modifierGroupIndex: number;
	modifierGroupsCount: number;
	title: string;
	description?: string;
	onModifierChange: (modifierGroupSelections: ModifierGroupSelections, changedModifierGroupId: ModifierGroupId) => void,
	onCloseClick: () => void,
	onAddToCartClick: () => void,
	onNextClick: () => void,
	onOverlayClick: () => void,
	onModifierDescriptionClick: (description: string, event: any) => void,
}

export const ModifierGroupEdit: FunctionComponent<ModifierGroupEditProps> =
	({
		 modifierGroup,
		 modifierGroupSelections,
		 modifierGroupIndex,
		 modifierGroupsCount,
		 title,
		 description,
		 onModifierChange,
		 onCloseClick,
		 onAddToCartClick,
		 onNextClick,
		 onOverlayClick,
		 onModifierDescriptionClick,
	 }) => {
		const translations = useContext(TranslationsContext);

		const selectedModifierIds = modifierGroupSelections.map(modifierSelection => modifierSelection.modifierId);

		return (
			<DrawerPopup
				key="modifierGroupEdit"
				title={title}
				description={description}
				headerBottomControl={
					<HeaderCard>
						<Stepper
							currentStep={modifierGroupIndex}
							maxSteps={modifierGroupsCount}
							currentStepText={modifierGroup.name}
						/>
					</HeaderCard>
				}
				leftControl={(<Button isText onClick={onCloseClick}>{
					getSafeTranslation('ModifierGroupEditPopup.closeButtonCaption', translations)
				}</Button>)
				}
				rightControl={
					onNextClick
						? (<Button isAutoWidth onClick={onNextClick}>{
							getSafeTranslation('ModifierGroupEditPopup.nextButtonCaption', translations)
						}</Button>)
						: (<Button isAutoWidth onClick={onAddToCartClick}>{
							getSafeTranslation('ModifierGroupEditPopup.addToCartButtonCaption', translations)
						}</Button>)

				}
				onOverlayClick={onOverlayClick}
			>
				<div className="modifier-group-edit">
					{
						modifierGroup.allowToChangeQuantity
							? <QuantitiesModifierGroupEdit
								modifierGroup={modifierGroup}
								modifierGroupSelections={modifierGroupSelections}
								onModifierChange={onModifierChange}
								onModifierDescriptionClick={onModifierDescriptionClick}
							/>
							: (modifierGroup.max === 1
							? <SelectOneModifierGroupEdit
								modifierGroup={modifierGroup}
								modifierGroupSelections={modifierGroupSelections}
								onModifierChange={onModifierChange}
								onModifierDescriptionClick={onModifierDescriptionClick}
							/>
							: <SelectManyModifierGroupEdit
								modifierGroup={modifierGroup}
								modifierGroupSelections={modifierGroupSelections}
								onModifierChange={onModifierChange}
								onModifierDescriptionClick={onModifierDescriptionClick}
							/>)
					}
				</div>
			</DrawerPopup>
		);
	};
